import * as React from "react";
import { VirtualNetworkToolbox20Filled, VirtualNetworkToolbox20Regular, FluentIcon, FluentIconsProps } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const NetworkingApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Networking" */ "./NetworkingApp");
    return { default: namedExport.NetworkingApp };
});

function createSize26Icon(iconType: FluentIcon): FluentIcon {
    const Icon = (props: FluentIconsProps) =>
        React.createElement(iconType, {
            ...props,
            style: { ...props.style, width: "26px", height: "26px" }
        });

    Icon.displayName = iconType.displayName && iconType.displayName + "Resized26";
    return Icon;
}

export const Networking: TeamAppConfig = {
    title: "Network Hub",
    regularIcon: createSize26Icon(VirtualNetworkToolbox20Regular),
    filledIcon: createSize26Icon(VirtualNetworkToolbox20Filled),
    description: "Views networking status, manages network devices and DNS records.",
    team: "Networking",
    publicId: "Exchange\\Networking",
    owner: "excnet@microsoft.com",
    role: "*",
    tags: [],
    app: NetworkingApp,
    path: "/Networking"
};
